const ENTITY_TO_LUXON_DATE_FORMAT = {
  'DD/MM/YYYY': 'dd/MM/yyyy',
  'MM/DD/YYYY': 'MM/dd/yyyy',
  'YYYY/MM/DD': 'yyyy/MM/dd',
};

/*
 * Get the Luxon date format from the company date format.
 * @param companyDateFormat - The company date format.
 * @param dateTime - The date time to format.
 * @param withDayOfWeek - If true, the date time will be formatted with the day of the week.
 * @param locale - Optional locale (e.g. from react-intl) so weekday and date respect app locale; otherwise Luxon uses system default.
 * @returns The formatted date time.
 */
export const getLuxonDateFormat = ({ companyDateFormat, dateTime, withDayOfWeek = false, locale = undefined }) => {
  const dt = locale ? dateTime.setLocale(locale) : dateTime;
  const companyDateFormatLuxon = ENTITY_TO_LUXON_DATE_FORMAT[companyDateFormat] || 'MM/dd/yyyy';
  const formattedDate = dt?.toFormat(companyDateFormatLuxon);

  if (withDayOfWeek) {
    const shortWeekday = dt?.toFormat('EEE');
    return `${shortWeekday} ${formattedDate}`;
  }
  return formattedDate;
};
